import type { EventAnalyticsResponse } from "@/queries/analytics/event-reporting-types";

export function hasMultipleEventOrigins(originCounts: EventAnalyticsResponse["originCounts"] | undefined): boolean {
  return (originCounts?.internal ?? 0) > 0 && (originCounts?.external ?? 0) > 0;
}
